module.exports = "<atn-list-box\r\n  #list\r\n  name=\"Administradores\"\r\n  outputField=\"name\"\r\n  [service]=\"administratorService\"\r\n  [duplicateOption]=\"false\"\r\n></atn-list-box>\r\n\r\n<administrator-form\r\n  *ngIf=\"list.showForm\"\r\n  [id]=\"list.selectedItemId\"\r\n  (onSave)=\"list.hideFormAndReload()\"\r\n  (onRemove)=\"list.hideFormAndReload()\"\r\n  (onBack)=\"list.hideForm()\"\r\n></administrator-form>"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/administrators/administrator-list/administrator-list.component.html
// module id = ./libs/atenea-cms/src/administrators/administrator-list/administrator-list.component.html
// module chunks = main